// Port of api/fuel/app/classes/filter/search/games/rules/query/rating.php
import Rule from 'offline/filter/core/search/rule'
import Util from 'offline/util'

export default Rule.create({
	name: 'rating',
	field: function() { return 'r.rating_value' },
	match: function(rule, config, filter, data, query) {
		var band = rule.setting && rule.setting.rating === 'band'
		if (rule.logic.operand === '=') {
			query.where(this.field(), '>=', Util.adjustedRatingAdvanced(Rule.value(rule), '=', false, band))
			query.where(this.field(), '<=', Util.adjustedRatingAdvanced(Rule.value(rule), '=', true, band))
		} else {
			query.whereGroup('OR', [
				[this.field(), '<', Util.adjustedRatingAdvanced(Rule.value(rule), '=', false, band)],
				[this.field(), '>', Util.adjustedRatingAdvanced(Rule.value(rule), '=', true, band)]
			])
		}
	},
	min: function(rule, config, filter, data, query) {
		var band = rule.setting && rule.setting.rating === 'band'
		query.where(this.field(), Rule.operand(rule, ['>=', '>']), Util.adjustedRatingAdvanced(Rule.value(rule), '=', false, band))
	},
	max: function(rule, config, filter, data, query) {
		var band = rule.setting && rule.setting.rating === 'band'
		query.where(this.field(), Rule.operand(rule, ['<=', '<']), Util.adjustedRatingAdvanced(Rule.value(rule), '=', true, band))
	},
	range: function(rule, config, filter, data, query) {
		var band = rule.setting && rule.setting.rating === 'band'
		query.where(this.field(), '>=', Util.adjustedRatingAdvanced(rule.logic.value, '=', false, band))
		query.where(this.field(), '<=', Util.adjustedRatingAdvanced(rule.logic.to, '=', true, band))
	},
	tolerance: function(rule, config, filter, data, query) {
		var band = rule.setting && rule.setting.rating === 'band'
		query.where(this.field(), '>=', Util.adjustedRating(Rule.value(rule), false) - rule.logic.tolerance)
		query.where(this.field(), '<=', Util.adjustedRating(Rule.value(rule), true) + rule.logic.tolerance)
	}
})
